import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-work-schedule-edit',
  standalone: false,
  templateUrl: './work-schedule-edit.component.html',
  styleUrl: './work-schedule-edit.component.scss',
})
export class WorkScheduleEditComponent implements OnInit {
  workScheduleId: number;

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit(): void {
    this.workScheduleId = this.route.snapshot.params['id'];
  }
}
